import React, {useState, useEffect} from 'react';
import {Container, Grid, Backdrop, Typography, CircularProgress, FormControl , FormGroup, FormControlLabel, Checkbox } from '@material-ui/core/';
import {Search, DeleteForever, Done, Visibility} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import BotonPersonalizado from 'components/BotonNormal'
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import Table from 'components/Table';
import LoadingSpinner from 'components/LoadingSpinner';
import MensajeAlerta from 'components/ResponseElement'
import { Alert } from '@material-ui/lab';
import CustomToolTip from 'components/tooltip/';
import ModalConfirmation from 'components/ModalConfirmation/ModalConfirmation';
import modalStyles from 'components/ModalConfirmation/styles';
import CitizenIdentityData from './citizenIdentityData';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import { useSelector, useDispatch } from 'react-redux'
import allActions from 'store/actions';

const citizenIdentityDataGlobal = [
    { tipo:'Fotografía', foto: ""},
    { tipo:'Firma', foto: ""},
    { tipo:'Huella', foto: ""},
];

const dataCitizenGeneral = {
    fullName: "",
    gender: "",
    dateOfBirth: "",
    birthPlace: "",
    fatherFullName: "",
    motherFullName: "",
    padronData: {
        codStatus: "",
        nombreStatus: "",
    }
}

function Homonimos(props) {
    const dispatch = useDispatch();
    const classes = useStyles(),
        classesModal = modalStyles(),
        [header, setHeader] = useState([
            { title: 'Código de Referencia', field: 'id', cellStyle: { maxWidth: '80px' } },
            { title: 'Nombre Completo', field: 'nombres', cellStyle: { maxWidth: '100px' } },
            { title: 'Estado Padrón', field: 'datosPadron.estadoPadron.nombreStatus'},
            { title: 'CUI del DPI', field: 'datosPadron.dpi.cui', cellStyle: { maxWidth: '100px' } },
            { title: 'Género', field: 'genero' },
            { title: 'Cédula', field: 'cedula' },
            { title: 'Departamento Cédula', field: 'departamentoCedula.nombre' },
            { title: 'Municipio Cédula', field: 'municipioCedula.name' },
            { title: 'Fecha Nacimiento', field: 'fechaNacimiento', render: (rowData) => functions.splitDate(rowData.fechaNacimiento) },
            { title: 'Departamento Nacimiento', field: 'departamentoNacimiento.nombre' },
            { title: 'Municipio Nacimiento', field: 'municipioNacimiento.name' },
            {
                title: 'Ver imágenes', field: 'showImages',
                render: rowData => <div>
                    {
                        <CustomToolTip title="VER FOTO, FIRMA, HUELLA" handleFunction={() => validarIdentidad(rowData)}><Visibility/></CustomToolTip>
                    }
                </div>
            },            
            { title: 'Acción', field: 'accion',
                render: rowData => <div>
                    <CustomToolTip title="Seleccionar ciudadano" handleFunction={() => seleccionarCiudadano(rowData)} ><Done /></CustomToolTip>
                </div>
            },                       
        ]),
        [loading, setLoading] = useState(false),
        [messageAlert, setMessageAlert] = useState(""),
        [controller] = useState("verificarHomonimos"),
        [checkAutorization, setCheckAutorization] = useState(false),
        [messageModal, setMessageModal] = useState(""),
        [dataConfirmation, setDataConfirmation] = useState({}),
        [citizenIdentityData, setCitizenIdentityData] = useState([...citizenIdentityDataGlobal]),
        [citizenIdentityDataGeneral, setCitizenIdentityDataGeneral] = useState({...dataCitizenGeneral}),
        [showCitizenIdentityData, setShowCitizenIdentityData] = useState(false),
        [loadingRequestImages, setLoadingRequestImages] = useState(false),
        [openModalAsociarCui, setOpenModalAsociarCui] = useState(false);

    const [state, setState] = useState({
        municipioNacimiento: false, departamentoNacimiento: false,  fechaNacimiento: true,  
        primerNombre: true, segundoNombre: true, primerApellido: true, segundoApellido: true, cui: false,
        cedula: false,      
    });
    let filters = {
        municipioNacio: 0, departamentoNacio: 0, fechaNacio: '',  nom1: '', nom2: '', ape1: '', ape2: '', cui: '', ordenCedula:'', registroCedula:''
    };

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };          
        
    const buscarInformacion = async ()=>{        
        setCheckAutorization(false);
        setLoading(true)
        setMessageAlert('Buscando Homónimos, Espere un momento por favor!')
        if(state.cui || state.primerNombre || state.segundoNombre || state.primerApellido || state.segundoApellido || state.cedula){
            if(state.municipioNacimiento) filters.municipioNacio = props.homonimos.municipioNacimiento.id.id;
            if(state.departamentoNacimiento) filters.departamentoNacio = props.homonimos.departamentoNacimiento.id;
            if(state.fechaNacimiento) filters.fechaNacio = functions.splitDate(props.homonimos.fechaNacimiento);
            if(state.primerNombre) filters.nom1 = props.homonimos.primerNombre;
            if(state.segundoNombre) filters.nom2 = props.homonimos.segundoNombre;
            if(state.primerApellido) filters.ape1 = props.homonimos.primerApellido;
            if(state.segundoApellido) filters.ape2 = props.homonimos.segundoApellido;
            filters.cui =               state.cui ? props.homonimos.cui : ''
            filters.ordenCedula =       state.cedula ? props.homonimos.ordenCedula : ''
            filters.registroCedula =    state.cedula ? props.homonimos.registroCedula : ''
            try {
                const hasPermission = await ApiServices.userSecurity.hasPermission('verificarHomonimos','list');    
                if (hasPermission.error){
                    setCheckAutorization(false);
                    showMessagePersonalizedPosition('error', '¡Advertencia! ' , hasPermission?.error?.message)
                    return;
                }                
                ApiServices[controller].initSearchCriteria.clear();
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("municipioNacio", filters.municipioNacio);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("departamentoNacio", filters.departamentoNacio);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("fechaNacio", filters.fechaNacio);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("nom1", filters.nom1);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("nom2", filters.nom2);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("ape1", filters.ape1);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("ape2", filters.ape2);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("cui", filters.cui);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("ordenCedula", filters.ordenCedula);  
                ApiServices[controller].initSearchCriteria.setOperator("and");
                ApiServices[controller].initSearchCriteria.addEquals("registroCedula", filters.registroCedula);                
                setCheckAutorization(true);             
            } catch (error) {
                if (error.status === 404) {
                    showMessagePersonalizedPosition('error', '¡Advertencia! ' , 'Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                } else {
                    showMessagePersonalizedPosition('error', '¡Advertencia! ' , 'Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }
            }
        }else{
            showMessagePersonalizedPosition('error', '¡Advertencia! ' ,'Tiene que filtrar como minimo CUI, Primer Nombre, Segundo Nombre, Primer Apellido, Segundo Apellido o Cédula.')
        }
        setLoading(false)
    }

    const limpiarFiltros = () => {
        setState({...state, primerNombre: false, segundoNombre: false, primerApellido: false, segundoApellido: false,
        cedula: false, genero: false, fechaNacimiento: false, departamentoNacimiento: false, municipioNacimiento: false})
    }

    const nextStep=()=>{
        // props.SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS(elements);
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+1);    
    };

    const beforeStep=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step-1);    
    };    

    const Cerrar=()=>{

        props.data.direccion = ""
        props.data.nocasalote = ""
        props.data.zona = ""
        props.data.departamento = ""
        props.data.municipio = ""
        props.data.comunidad = ""            
        props.data.profesion = ""      

        props.homonimos.primerNombre = ""
        props.homonimos.segundoNombre = ""
        props.homonimos.primerApellido = ""
        props.homonimos.segundoApellido = ""
        props.homonimos.cedula = ""
        props.homonimos.genero = ""            
        props.homonimos.fechaNacimiento = ""    
                
        beforeStep()
        props.cerrarDialogo()     
    };    

    const CancelarSolicitud=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD(true)
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+2);
    };

    // useEffect(() => {
    //     buscarInformacion()
    // }, [])
    const validarIdentidad =async (data)=>{
        setLoadingRequestImages(true)
        setCitizenIdentityData([...citizenIdentityDataGlobal]);
        setCitizenIdentityDataGeneral({...dataCitizenGeneral})
        setShowCitizenIdentityData(false)
        const {datosPadron = {}, genero ="", fechaNacimiento= ""} = data;
        const newData = {};
        newData.fullName = `${datosPadron?.primerNombre ? datosPadron?.primerNombre : ""} ${datosPadron?.segundoNombre ? datosPadron?.segundoNombre : ""} , ${datosPadron?.primerApellido ? datosPadron?.primerApellido : ""} ${datosPadron?.segundoApellido ? datosPadron?.segundoApellido : ""} `;
        newData.gender = genero;
        newData.dateOfBirth = fechaNacimiento;
        newData.birthPlace = `${datosPadron.dpi?.municipioNacimientoRenap?.name ? `${datosPadron.dpi?.municipioNacimientoRenap?.name}, ` : ""} ${datosPadron.dpi?.departamentoNacimientoRenap?.name ? datosPadron.dpi?.departamentoNacimientoRenap?.name: ""}`;
        newData.fatherFullName = `${datosPadron?.complemento?.primerNombrePadre ? datosPadron?.complemento?.primerNombrePadre : ""} ${datosPadron?.complemento?.segundoNombrePadre ? datosPadron?.complemento?.segundoNombrePadre : ""} , ${datosPadron?.complemento?.primerApellidoPadre ? datosPadron?.complemento?.primerApellidoPadre : ""} ${datosPadron?.complemento?.segundoApellidoPadre ? datosPadron?.complemento?.segundoApellidoPadre : ""} `;
        newData.motherFullName = `${datosPadron?.complemento?.primerNombreMadre ? datosPadron?.complemento?.primerNombreMadre : ""} ${datosPadron?.complemento?.segundoNombreMadre ? datosPadron?.complemento?.segundoNombreMadre : ""} , ${datosPadron?.complemento?.primerApellidoMadre ? datosPadron?.complemento?.primerApellidoMadre : ""} ${datosPadron?.complemento?.segundoApellidoMadre ? datosPadron?.complemento?.segundoApellidoMadre : ""} `;
        newData.padronData = datosPadron?.estadoPadron ? datosPadron?.estadoPadron : {};

        if(!data.datosPadron?.dpi?.cui) {
            setLoadingRequestImages(false)
            setShowCitizenIdentityData(true)
            setCitizenIdentityDataGeneral(newData);
            return;
        }

        try{
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosPadron?.dpi?.cui);
            if(response.error){
                setShowCitizenIdentityData(true)
                setCitizenIdentityDataGeneral(newData)
            } else {
                const {object} = response.data;

                if(!object) {
                    setShowCitizenIdentityData(true)
                    setCitizenIdentityDataGeneral(newData)
                }
                let newCitizenIdentityData = [];

                newCitizenIdentityData.push({ tipo:'Fotografía', foto: `data:image/jpeg;base64,${object.fotoCiudadano}`});
                newCitizenIdentityData.push({ tipo:'Firma', foto: `data:image/jpeg;base64,${object.firmaCiudadano}`});
                newCitizenIdentityData.push({ tipo:'Huella', foto: `data:image/jpeg;base64,${object.huellaCiudadano}`});
    
                setShowCitizenIdentityData(true)
                setCitizenIdentityData(newCitizenIdentityData)
                setCitizenIdentityDataGeneral(newData)
            } 
        }catch(exception){
            // setOpen(true);
            // (exception.status===404)  ? setMensaje({ tipoError: 'error', tipoMensaje: "Falla del sistema" })
            // : setMensaje({ tipoError: 'error', tipoMensaje: `¡Oops! ${exception.message}`})
        }            
        setLoadingRequestImages(false);
    }
    const closeShowCitizenIdentityData = () => {
        setShowCitizenIdentityData(false)
    }

    const seleccionarCiudadano = (data) => {
        dispatch(allActions.setNumeroBoletaRenap(data?.datosPadron?.nroBoleta));
        nextStep()
        // setDataConfirmation({});
        // setMessageModal("");
        // if(data.datosPadron.dpi) {
        //     if(Number(data.status) === 16) {
        //         setMessageModal(`Usted va asociar el número de cui ${props.datosCiudadanoTable?.datosDpiSolicitudEmpadronamiento?.cui} al número de boleta ${data.datosPadron?.nroBoleta} del ciudadano ${data?.nombres}`)
        //         setOpenModalAsociarCui(true);
        //         return setDataConfirmation({...data, isCuiDistint : false, })
        //     }            
        // }
    }
    // Setear la data y mover al paso siguiente
    const nextStepCitizenSelected = (data) => {
        // props.SET_DATA_HOMONIMO_CIUDADANO(data)
    }
    const sendDataConfirmation = () => {
        nextStepCitizenSelected(dataConfirmation)
        nextStep();
    }
    const cerrarModalAsociarCuiStatus16 = ()=>{
        setOpenModalAsociarCui(false)
    }
    return (
        <div className={classes.root}>
            <LoadingSpinner open={loading} message={messageAlert} />
            <LoadingSpinner open={loadingRequestImages} message="Buscando datos de identidad, Espere un momento por favor!" />
            <div  className={classes.colorComponente}>
                <Grid container className={classes.marginGrid} >
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body1" color="textPrimary"> <strong>Homónimos</strong></Typography>
                    </Grid>                                      
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value={props.homonimos.primerNombre}
                                    control={<Checkbox color="primary" checked={state.primerNombre} onChange={handleChange} name="primerNombre" />}
                                    label={"Primer Nombre: "+ ((props.homonimos.primerNombre === null) ? "" : props.homonimos.primerNombre)}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value={props.homonimos.segundoNombre}
                                    control={<Checkbox color="primary" checked={state.segundoNombre} onChange={handleChange} name="segundoNombre" />}                                    
                                    label={"Segundo Nombre: "+ ((props.homonimos.segundoNombre === null) ? "" : props.homonimos.segundoNombre)}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value={props.homonimos.primerApellido}
                                    control={<Checkbox color="primary" checked={state.primerApellido} onChange={handleChange} name="primerApellido" />}
                                    label={"Primer Apellido: "+ ((props.homonimos.primerApellido === null) ? "" : props.homonimos.primerApellido)}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value={props.homonimos.segundoApellido}
                                    control={<Checkbox color="primary" checked={state.segundoApellido} onChange={handleChange} name="segundoApellido" />}
                                    label={"Segundo Apellido: "+ ((props.homonimos.segundoApellido === null) ? "" : props.homonimos.segundoApellido)}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox color="primary" checked={state.cui} onChange={handleChange} name="cui" />}
                                    label={"CUI: "+ props.homonimos.cui || ''}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox color="primary" checked={state.cedula} onChange={handleChange} name="cedula" />}
                                    label={"Cédula: "+ ((props.homonimos.ordenCedula+'-') || '') + props.homonimos.registroCedula || ''}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox color="primary" checked={state.fechaNacimiento} onChange={handleChange} name="fechaNacimiento" />}
                                    label={"Fecha Nacimiento: "+ ((props.homonimos.fechaNacimiento === null) ? "" : functions.splitDate(props.homonimos.fechaNacimiento))}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox color="primary" checked={state.departamentoNacimiento} onChange={handleChange} name="departamentoNacimiento" />}
                                    label={"Departamento Nacimiento: "+ ((props.homonimos.departamentoNacimiento === null) ? "" : props.homonimos.departamentoNacimiento.name)}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >             
                    <Grid item xs={3} container direction="row" justify="flex-start" alignItems="flex-start">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormGroup>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox color="primary" checked={state.municipioNacimiento} onChange={handleChange} name="municipioNacimiento" />}
                                    // label={"Municipio Nacimiento: "+ props.homonimos.municipioNacimiento.name}
                                    label={"Municipio Nacimiento: "+ ((props.homonimos.municipioNacimiento === null) ? "" : props.homonimos.municipioNacimiento.name)}
                                    labelPlacement="end"
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid >            
                    <Grid item xs={12} className={classes.buttons}>
                        <BotonPersonalizado title={"Buscar"}  botonPersonalizado={true} function={buscarInformacion} icon={<Search />}  loading={loading} disabled={loading}/> 
                        <BotonPersonalizado title={"Limpiar Filtros"}  botonPersonalizado={true} function={limpiarFiltros} icon={<DeleteForever />} /> 
                    </Grid>                                         
                    <Grid item xs={12} className={classes.buttons}>
                        {
                            (checkAutorization ) ?
                                <Table
                                    service={ApiServices[controller]}
                                    // pageSize={this.state.pageSize}
                                    isGetData={checkAutorization}
                                    title={"Listado de Homónimos"}
                                    header={header}
                                    showFilter={false}
                                    showFilterGeneral={false}                                    
                                    // data={listHomonimos}
                                    // refreshList={this.showList}
                                    // detailPanel={}
                                    // addRegister={this.addRegister}
                            /> :
                                <Alert className={classes.marginAlert} variant="outlined" severity="warning">Si desea buscar Homónimos, de clic en el botón "BUSCAR"</Alert>
                        }
                    </Grid>                     
                    <Grid item xs={12} className={classes.buttons}>
                        <BotonPersonalizado title={"Regresar"} botonAnterior={true} function={beforeStep} />
                        <BotonPersonalizado title={"Siguiente"} botonSiguiente={true} function={nextStep}/>
                        <BotonPersonalizado title={"Rechazar"}  botonRechazarDocumento={true} function={CancelarSolicitud} /> 
                        <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={Cerrar}/>
                    </Grid>                     
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
                {/* Modal para asociar un usuario con cedula a cui */}
                <ModalConfirmation
                    actionAdd={sendDataConfirmation}
                    open={openModalAsociarCui}
                    closeModal={cerrarModalAsociarCuiStatus16}
                    titleButton="Sí, estoy seguro!"
                >
                    <Typography className={classesModal.title} > {messageModal} </Typography>
                    <Typography className={classesModal.description} > ¿Está seguro de continuar? </Typography>
                </ModalConfirmation>      
                <CitizenIdentityData citizenIdentityData={citizenIdentityData} showCitizenIdentityData={showCitizenIdentityData} closeShowCitizenIdentityData={ closeShowCitizenIdentityData } citizenIdentityDataGeneral={citizenIdentityDataGeneral}/>          
            </div><br/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(Homonimos);